import { useWindowSize, useDebounceFn, useEventListener } from '@vueuse/core'
import { pxToRem } from '@/lib/math'

export const setViewportsCssVar = () => {
    const { width, height } = useWindowSize({
        type: 'visual'
    })
    const setCssVar = () => {
        document.documentElement.style.setProperty('--vw', pxToRem(width.value))
        document.documentElement.style.setProperty('--vh', pxToRem(height.value))

        const containerSideGap2xl = (width.value - 1536) / 2
        const containerSideGapXl = (width.value - 1140) / 2
        const containerSideGapLg = (width.value - 960) / 2
        const containerSideGapMd = (width.value - 768) / 2
        const containerSideGapSm = (width.value - 520) / 2

        document.documentElement.style.setProperty('--container-side-gap-2xl', pxToRem(containerSideGap2xl))
        document.documentElement.style.setProperty('--container-side-gap-xl', pxToRem(containerSideGapXl))
        document.documentElement.style.setProperty('--container-side-gap-lg', pxToRem(containerSideGapLg))
        document.documentElement.style.setProperty('--container-side-gap-md', pxToRem(containerSideGapMd))
        document.documentElement.style.setProperty('--container-side-gap-sm', pxToRem(containerSideGapSm))
    }
    setCssVar()
    const debouncedSetCssVar = useDebounceFn(() => {
        setCssVar()
    }, 100)
    useEventListener(window, 'resize', debouncedSetCssVar)
}